import { z } from 'zod'
import { SuggestRequest } from './api/suggestions'

export const QUEUE_NAMES = [
  'classify-conversation',
  'refetch-meta-object',
  'fetch-post',
  'generate-suggestion',
  'ingest-kb-source',
  'retire-corpus-for-source',
  'check-channel-health',
  'sweep-channel-health',
  'sweep-inbound-outbox',
  'sweep-stranded-replies',
  'sweep-auto-suggestion-outbox',
  'sla-sweep',
  'redact-expired',
  'prune-auth-state',
  'notify-inbox',
] as const
export type QueueName = (typeof QUEUE_NAMES)[number]

const TenantScoped = z.object({ tenantId: z.uuid() })

export const JOB_PAYLOADS = {
  'classify-conversation': TenantScoped.extend({ conversationId: z.uuid(), messageId: z.uuid() }),
  'refetch-meta-object': TenantScoped.extend({
    channelId: z.uuid(),
    objectType: z.enum(['comment', 'message']),
    externalId: z.string().min(1),
  }),
  'fetch-post': TenantScoped.extend({ channelId: z.uuid(), externalPostId: z.string().min(1) }),
  'generate-suggestion': TenantScoped.extend({
    conversationId: z.uuid(),
    requestedBy: z.union([z.literal('auto'), z.uuid()]),
    sourceIds: SuggestRequest.shape.sourceIds,
  }),
  'ingest-kb-source': TenantScoped.extend({ kbSourceId: z.uuid() }),
  'retire-corpus-for-source': TenantScoped.extend({ kbSourceId: z.uuid() }),
  'check-channel-health': TenantScoped.extend({ channelId: z.uuid() }),
  'sweep-channel-health': z.strictObject({}),
  'sweep-inbound-outbox': z.strictObject({}),
  'sweep-stranded-replies': z.strictObject({}),
  'sweep-auto-suggestion-outbox': z.strictObject({}),
  'sla-sweep': z.strictObject({}),
  'redact-expired': z.strictObject({}),
  'prune-auth-state': z.strictObject({}),
  'notify-inbox': TenantScoped.extend({ conversationId: z.uuid(), messageId: z.uuid() }),
} as const satisfies Record<QueueName, z.ZodType>

export type JobPayload<Q extends QueueName> = z.infer<(typeof JOB_PAYLOADS)[Q]>

export const deadLetterQueueName = <Q extends QueueName>(queue: Q): `${Q}-dlq` => `${queue}-dlq`

export const JOB_RETRY_POLICY = {
  retryLimit: 5,
  retryDelay: 30,
  retryBackoff: true,
  retryDelayMax: 900,
} as const
